// extracted by mini-css-extract-plugin
export default {"projetosfera_logo":"login_projetosfera_logo__oW-UC"};